import React from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';

import { AppState } from '../../reducers';
import { humanizeEnum } from '../../utils';
import { Button } from './button';
import { Dot } from './dot';
import { basic } from '../../theme/colors';

interface OwnProps {
  name: string;
  identifier: string;
  onClick?: (id: string) => void;
  classNames?: string;
  tooltip?: string;
  shouldBreak?: boolean;
}

interface Props extends OwnProps {
  eventTags: any[];
}

export class EventTypeTag extends React.Component<Props, any> {
  getColor = (): string => {
    return `#${this.props.eventTags.find((et) => et.identifier === this.props.identifier)?.marker_color_hex}` || 'gray';
  };

  render() {
    const { identifier, onClick, classNames, shouldBreak, ...passProps } = this.props;
    const text = this.props.eventTags.find((et) => et.identifier === this.props.identifier)?.name ?? humanizeEnum(this.props.identifier);
    const arr = text.split(' - ');
    return (
      <ButtonTag
        className={`btn btn-sm btn-light ${classNames}`}
        onClick={() => onClick && onClick(identifier)}
        data-test="event-type-tag"
        {...passProps}
      >
        <Dot color={this.getColor()} size="sm" />
        {shouldBreak ? (
          <>
            {arr[0]}
            {arr.length > 1 && <br />}
            {arr[1] && (
              <>
                <Dot color="transparent" size="sm" />
                {arr[1]}
              </>
            )}
          </>
        ) : (
          text
        )}
      </ButtonTag>
    );
  }
}

const mapStateToProps = (state: AppState, ownProps: OwnProps): Props => {
  return {
    eventTags: state.store.eventTags,
    ...ownProps,
  };
};

export default connect(mapStateToProps)(EventTypeTag);

export const ButtonTag = styled(Button)<{ allowedListed?: boolean }>`
  border-radius: 5px;
  background-color: white;
  color: ${basic.haydenAnthracite};
  transition:
    300ms linear background,
    border;
  border: 1px solid ${basic.haydenLight};

    ${({ allowedListed }) =>
      allowedListed &&
      css`
        position: relative;
        top: 0;
        overflow: hidden;

        &:after {
          content: '';
          position: absolute;
          top: -6px;
          left: 3px;
          background: #28a745;
          display: block;
          width: 5px;
          height: 30px;
          transform: rotate(45deg);
        }
      `};

  &:active,
  &:focus {
    box-shadow: none;
    outline: none;
    background-color: white;
    border-color: ${basic.haydenLightSteel};
  }

  &:hover {
    background-color: ${basic.haydenLight2};
    border-color: ${basic.haydenLightSteel};
  }

  &.selected {
    border: 1px solid ${basic.haydenDarkSand}
    z-index: 10;
  }

  &.text-left {
    text-align: left;
  }

  &.btn.no-cursor {
    /* need this to break bootstrap inheritance */
    cursor: default;

    &:hover {
      background: white;
      border: 1px solid ${basic.haydenLight};
    }
  }
`;
